import styled from "styled-components";

export const ContainerInput = styled.div`
    padding-top: 25px;
`;
export const BoldText = styled.span`
    font-weight: 500;
`;